import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import sagas from '@store/sagas/index';
import { createRouterMiddleware } from '@lagunovsky/redux-react-router';
import { browserHistory } from '@utils/history';
import { rootReducer } from './reducers';

const routerMiddleware = createRouterMiddleware(browserHistory);
let store: ReturnType<typeof configureStore> | null = null;

export function createStore() {
  if (store) return store;

  const sagaMiddleware = createSagaMiddleware();
  const middleware = [sagaMiddleware, routerMiddleware];

  store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
    devTools: process.env.NODE_ENV !== 'production'
  });

  sagaMiddleware.run(sagas);

  return store;
}

export function getStore() {
  if (!store) {
    store = createStore();
  }
  return store;
}

export default store;
